<template>
  <div>
    <q-img :src="imageSrc" :width="Width" :height="Height" :ratio="1" @click="handleImageClick">
    </q-img>
    <q-dialog v-model="showProductImg" >
      <q-card style="width: 700px; max-width: 80vw;">
        <q-card-section>
          <div class="text-h6">{{ ProductTitle }}</div>
        </q-card-section>

        <q-img :src="imageSrc" :ratio="1">
        </q-img>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>

</template>

<script>
  export default {
    name: "ProductImage",
    props: {
      imageSrc: {
        type: String,
        required: true
      },
      Width: {
        type: String,
      },
      Height: {
        type: String,
      },
      ProductTitle: {
        type: String,
      }
    },
    data() {
      return {
        showProductImg: false
      }
    },
    methods: {
      handleImageClick() {
        this.showProductImg = true
      }
    }
  }
</script>